import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FormGroup, Label, Input } from 'reactstrap';
import './ShippingCart.scss';
import { auth } from '../../../../../../services';
import { addProducttoCart, completePurchase, toggleToastr, getCartItems, addtoCart, removeProductFromCart, updateProductInCart, updateBilling, updateShipping, updateCard } from '../../../../../../Redux/Actions/EndUser/StoreActions';
import { Link } from 'react-router-dom';
import { Alert } from 'reactstrap';
import IsLoading from '../../../../../Shared/Loading/IsLoading';
import { NumericTextBox } from '@progress/kendo-react-inputs';

import StoreCardInfo from '../StoreCardInfo';
import StoreBillingInfo from '../StoreBillingInfo';
import StoreShippingInfo from '../StoreShippingInfo';
import { store } from '../../../../../../services/store.service';


class ShoppingCart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //cartItems:[],
            touched: {
                Address1: false,
                Address2: false,
                City: false,
                StateObject: false,
                Zip: false,
                BillingAddress1: false,
                BillingAddress2: false,
                BillingCity: false,
                BillingState: false,
                BillingZip: false,
                NameOnCard: false,
                CardNumber: false,
                CardExpYear: false,
                CardExpMonth: false,
                CardCVC: false
            },

            cartDetails:{}
        };
    }

    componentDidMount = () => {
        //his.setState({
            this.props.getCartItems()
       // })
        
         this.setState({
             orderDetails:store.calculateCheckoutTotal()
         })
    }

    removeFromCart = (product) => {
        this.props.removeProductFromCart(
            product,
            this.props.store.cartItems
        );
        this.setState({
            orderDetails: store.calculateCheckoutTotal()
        })
    }

    handleQuantityChange = (event, product) => {
        if (event.value > product.Quantity) {
            product.Quantity++;
        }
        else {
            product.Quantity--;
        }
        this.props.updateProductInCart(product, this.props.store.cartItems);
        this.setState({
            orderDetails: store.calculateCheckoutTotal()
        })
    }

    setAllTouchedTrue() {
        this.setState({
            touched: {
                Address1: true,
                Address2: true,
                City: true,
                StateObject: true,
                Zip: true,
                BillingAddress1: true,
                BillingAddress2: true,
                BillingCity: true,
                BillingState: true,
                BillingZip: true,
                NameOnCard: true,
                CardNumber: true,
                CardExpYear: true,
                CardExpMonth: true,
                CardCVC: true
            }
        })
    }

    isModelValid() {
        return this.props.store.shippingInfo && this.props.store.billingInfo &&
            this.props.store.shippingInfo.Address1 !== "" && this.props.store.shippingInfo.Address1 !== undefined &&
            this.props.store.shippingInfo.City !== "" && this.props.store.shippingInfo.City !== undefined &&
            this.props.store.shippingInfo.StateObject.name !== "" && this.props.store.shippingInfo.StateObject.name !== undefined &&
            this.props.store.shippingInfo.Zip !== "" && this.props.store.shippingInfo.Zip !== undefined &&
            this.props.store.billingInfo.BillingAddress1 !== "" && this.props.store.billingInfo.BillingAddress1 !== undefined &&
            this.props.store.billingInfo.BillingCity !== "" && this.props.store.billingInfo.BillingCity !== undefined &&
            this.props.store.billingInfo.BillingState.name !== "" && this.props.store.billingInfo.BillingState.name !== undefined &&
            this.props.store.billingInfo.BillingZip !== "" && this.props.store.billingInfo.BillingZip !== undefined &&
            this.props.store.creditCard.NameOnCard !== "" && this.props.store.creditCard.NameOnCard !== undefined &&
            this.props.store.creditCard.CardNumber !== "" && this.props.store.creditCard.CardNumber !== undefined &&
            this.props.store.creditCard.CardExpYear !== "" && this.props.store.creditCard.CardExpYear !== undefined &&
            this.props.store.creditCard.CardExpMonth !== "" && this.props.store.creditCard.CardExpMonth !== undefined &&
            this.props.store.creditCard.CardCVC !== "" && this.props.store.creditCard.CardCVC !== undefined;
    }

    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        let t = this.total();

        if (this.isModelValid()) {
            
            this.props.completePurchase(
                {
                    ...this.props.store,
                    UserId: this.props.authentication.user.userId,
                    Subtotal: this.state.orderDetails.subTotal,
                    Tax: this.state.orderDetails.tax,
                    Shipping: this.state.orderDetails.shipping,
                    TotalCost: this.state.orderDetails.totalCost
                }, this.props.authentication.user
            ).then(() => {
                //console.log(err);

                this.props.updateBilling();
                this.props.updateShipping();
                this.props.updateCard();
            });
            
        } else {
            this.setAllTouchedTrue();
        }

    }

    subTotal = () => {
        var total = 0;
        if (this.props.store.cartItems.length > 0) {
            this.props.store.cartItems.map((product, key) => {
                if (product.Discount) {
                    total = (product.Discount * product.Quantity) + total;
                } else {
                    total = (product.Cost * product.Quantity) + total;
                }
            })
        }
        return total.toFixed(2);
    }

    tax = () => {
        var tax = 0;
        if (this.props.store.cartItems.length > 0) {
            tax += (Number(Number(Number(this.shipping() * 0.0825).toFixed(2)) + Number(tax))).toFixed(2);

            this.props.store.cartItems.map((product, key) => {
                if (product.Discount) {
                    tax = Number(Number(Number(Number(product.Discount * product.Quantity) * 0.0825).toFixed(2)) + Number(tax));
                } else {
                    tax = Number(Number(Number(Number(product.Cost * product.Quantity) * 0.0825).toFixed(2)) + Number(tax));
                }
            })
        }
        return tax.toFixed(2);
    }

    shipping = () => {
        return (8.25).toFixed(2);
    }

    total = () => {
        return Number(Number(this.subTotal()) + Number(this.tax()) + Number(this.shipping())).toFixed(2);
    }

    render() {
        return (
            <div className="shoppingCart">
				{this.props.common.loading ? (
						<IsLoading message="Placing Order" />
					) : (
                <div className="row vh100">
                    <div className="col-lg-8 productDetailsContainer">
                        <div className="cartHeader">
                            <h1>Shopping Cart</h1>
                            <p className="cartAmount">{this.props.store.cartTotal} <span>Items</span></p>
                        </div>
                        <div className="cartProducts">
                            <div className="row cartProducts-header">
                                <div className="col-md-5 productRow-content"><p className="productTitle">PRODUCT DETAILS</p></div>
                                <div className="col-md-2 productRow-content"><p className="productTitle">SIZE</p></div>
                                <div className="col-md-1 productRow-content"><p className="productTitle">QUANTITY</p></div>
                                <div className="col-md-2 productRow-content"><p className="productTitle">PRICE</p></div>
                                <div className="col-md-2 productRow-content"><p className="productTitle totalPrice">TOTAL</p></div>
                            </div>
                            {this.props.store.cartItems ? this.props.store.cartItems.map((product, index) => {
                                return (
                                    <div className="row productRow" key={index}>
                                        <div className="col-md-4 productRow-content">
                                            <div className="productImageDetails">
                                                <div className="product-image">
                                                    {
                                                        product.ImageUrl ?
                                                        <img src={product.ImageUrl} alt={product.productName} />:
                                                        <img src="/images/TSCRABackgroundLOGO.png" className="defaultImgHeight" alt="..." />
                                                    }
                                                </div>
                                                
                                                <div className="product-text">
                                                    <p className="productName">{product.ProductName}</p>
                                                    {product.Color ?
                                                        <p className="productColor">
                                                            <span className="productColor-header">Color</span>
                                                            <span>{product.Color}</span>
                                                        </p>
                                                        : ""}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2 productRow-content productRow-content-text">
                                            <span className="productColor-header-text">Size</span>
                                            <p className="productInfo">{product.Size}</p>
                                        </div>
                                        <div className="col-md-1 productRow-content productRow-content-text">
                                            <span className="productColor-header-text">Quantity</span>
                                            <NumericTextBox
                                                defaultValue={product.Quantity}
                                                value={product.Quantity}
                                                onChange={(e) => this.handleQuantityChange(e, product)}
                                                step={1}
                                                min={1}
                                            />
                                            <span className="remove-product" onClick={() => this.removeFromCart(product)}>Remove</span>
                                        </div>
                                        <div className="col-md-2 productRow-content productRow-content-text">
                                            <span className="productColor-header-text">Price</span>
                                            {product.Discount ?
                                                <div>
                                                    <p className="productInfo" style={{ textDecoration: "line-through"}}>${(product.Cost).toFixed(2)}</p>
                                                    <p className="productInfo">${(product.Discount).toFixed(2)}</p>
                                                </div>
                                                : <p className="productInfo">${(product.Cost).toFixed(2)}</p>
                                            }
                                        </div>
                                        <div className="col-md-2 productRow-content productRow-content-text">
                                            <span className="productColor-header-text">Total</span>
                                            {product.Discount ?
                                                <p className="productInfo highlightPrice totalPrice">${(product.Discount * product.Quantity).toFixed(2)}</p>
                                                :
                                                <p className="productInfo highlightPrice totalPrice">${(product.Cost * product.Quantity).toFixed(2)}</p>
                                            }
                                        </div>
                                    </div>
                                )
                            }) : ""}
                           
                                </div>
                                {this.props.store.cartItems.length > 0 ?
                                    (<div>
                                        <div className="prices">
                                            <div className="cartPriceTitles">
                                                <p>Subtotal</p>
                                                <p>Tax</p>
                                                <p>Shipping</p>
                                            </div>
                                            <div className="cartPrices">
                                                <p>${this.state.orderDetails ? this.state.orderDetails.subTotal: ""}</p>
                                                <p>${this.state.orderDetails ? this.state.orderDetails.tax : ""}</p>
                                                <p>${this.state.orderDetails ? this.state.orderDetails.shipping : ""}</p>
                                            </div>
                                        </div>
                                        <div className="totals">
                                            <p>Total Cost</p>
                                            <p>${this.state.orderDetails ? this.state.orderDetails.totalCost : ""}</p>
                                        </div>
                                        <Link to='/store' className="backToStoreBtn" >
                                            <img src="/images/back-to-events-arrow.png" alt="back to store" />Continue Shopping
                                        </Link>
                                    </div>)
                                    :
                                    (<div>
                                        <div className="prices">
                                            <div className="cartPriceTitles">
                                                <p>Cart Empty</p>
                                            </div>
                                            <div className="cartPrices">
                                            </div>
                                        </div>
                                        <div className="totals">
                                        </div>
                                        <Link to='/store' className="backToStoreBtn" >
                                            <img src="/images/back-to-events-arrow.png" alt="back to store" />Continue Shopping
                                        </Link>
                                    </div>)
                                    }
                      
                    </div>
                            {this.props.store.cartItems.length >0 ? (
                                <div className="col-lg-4 checkoutContainer">
                                    <div className="orderTitle">
                                        <div className="cartHeader">
                                            <h1>Order Summary</h1>
                                        </div>
                                        {this.props.common.visible ? (
                                            <Alert
                                                color={this.props.common.color}
                                                isOpen={this.props.common.visible}
                                                toggle={() => {
                                                    this.props.toggleToastr(false)
                                                }}
                                                style={{ width: '100%' }}>
                                                {this.props.common.message}
                                            </Alert>
                                        ) : null}
                                        <div>
                                            <div className="card">
                                                <h2>Shipping Information</h2>
                                                <StoreShippingInfo handleBlur={this.handleBlur} touched={this.state.touched} />
                                            </div>
                                            <div className="card">
                                                <h2>Billing Information</h2>
                                                <StoreBillingInfo handleBlur={this.handleBlur} touched={this.state.touched} />
                                            </div>
                                            <div className="card">
                                                <h2>Payment Information</h2>
                                                <StoreCardInfo handleBlur={this.handleBlur} touched={this.state.touched} />
                                            </div>
                                        </div>
                                        <button className="checkoutBtn" onClick={this.handleSubmit}>Checkout</button>
                                    </div>
                                </div>
                                ) : (
                                    <div className="col-lg-4 checkoutContainer">
                                        <div className="orderTitle">
                                            <div className="cartHeader">
                                                <h1>Order Summary</h1>
                                            </div>
                                            <div>
                                                <div className="card">
                                                    <h2>Empy Cart</h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                   
                </div>)}
            </div>    
        );
    }
}

function mapStateToProps(state) {
    return {
        authentication: state.authentication,
        store: state.store,
        common: state.common
    }
}

export default withRouter(connect(mapStateToProps, { addProducttoCart, completePurchase, toggleToastr, getCartItems, addtoCart, removeProductFromCart, updateProductInCart, updateBilling, updateShipping, updateCard})(ShoppingCart));